import script from "./NationalityInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NationalityInput.vue?vue&type=script&setup=true&lang=js"

import "./NationalityInput.vue?vue&type=style&index=0&id=57d4ac38&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d4ac38"]])

export default __exports__